import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageStateService {
  private currentPageStateSubject: BehaviorSubject<any>;
  public currentPageState$: Observable<any>;
  private localStorageKey = 'dposPosPageState';

  constructor() {
    this.currentPageStateSubject = new BehaviorSubject<any>(this.getCurrentPageStateFromLocalStorage());
    this.currentPageState$ = this.currentPageStateSubject.asObservable();
  }

  setCurrentPageState(data: any) {
    this.currentPageStateSubject.next(data);
    this.saveCurrentPageStateToLocalStorage(data);
  }

  getCurrentPageState(pageUrl?: string): any {
    if (pageUrl !== this.currentPageStateSubject?.value?.currentRoute) {
     this.removeCurrentPageStateFromLocalStorage();
     return null;
    }
    return this.currentPageStateSubject.value;
  }

  private getCurrentPageStateFromLocalStorage(): any {
    const dataJson = localStorage.getItem(this.localStorageKey);

    return dataJson === null || dataJson === 'undefined' ? null : JSON.parse(dataJson);
  }

  private saveCurrentPageStateToLocalStorage(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  public removeCurrentPageStateFromLocalStorage() {
    localStorage.removeItem(this.localStorageKey);
  }
}
